import { CanalAtendimento } from "../models/segmento";
import { IBaseGuidDTO, BaseGuidDTO } from "./dto.base";


export interface ISegmentoDTO extends IBaseGuidDTO {

    Codigo: string;
    Descricao: string;

}

export class SegmentoDTO extends BaseGuidDTO implements ISegmentoDTO {

    Codigo: string;
    Descricao: string;
    constructor(data: any = {}) {
        super(data);
        this.Codigo = data.Codigo;
        this.Descricao = data.Descricao;
    }
}